import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';

export const IconMinus = (props: IconProps) => (
  <svg className={cn(iconStyles(props))} viewBox="0 0 11 11">
    <path d="M1 5.5h9" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
